export default function ParseVerbatimsToHTML(verbatims) {
    const verbatimsElement = document.createElement("ul")
    verbatims.verbatims.forEach(element => {
        let li = document.createElement("li")
        li.textContent = element
        verbatimsElement.appendChild(li)
      })
    return verbatimsElement.outerHTML
}